<app-dialog-header label={{title}}></app-dialog-header>
<div>
    <app-form-multi-select style="margin:1vh" tituloMultiSelect={{title}} [data]="this.multiSelectData" 
    [(selectedValues)]="this.selectedValues" maxItems="100">
    </app-form-multi-select>
    <button class="btn btn-primary" style="float: right;margin: 1vh;" (click)="save()" i18n>Guardar</button>
</div>
